import { PropsWithChildren } from "react";
import { Col, Col1, Spinner, TextTitle } from "../lib";

type Props = PropsWithChildren<{
  title?: string;
}>;

export function LoadingScreen({ children, title }: Props) {
  return (
    <Col1.C>
      <Col.C>
        {!!title && <TextTitle mb="4">{title}</TextTitle>}
        <Spinner large />
        {!!children && <Col1 mt="4">{children}</Col1>}
      </Col.C>
    </Col1.C>
  );
}
